import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/secretKeyManage',
  name: 'secretManage',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/secretKeyManage',
      component: () => import('@/views/operation/secretKeyManage/index.vue'),
      meta: {
        title: '秘钥管理',
        icon: 'key'
      }
    }
  ]
}
